export const getBGColor = (status: string): string => {
  switch (status) {
    case 'step_1':
      return '#E9D8FD';
    case 'step_2':
      return '#FAF089';
    case 'step_3':
      return '#FAF089';
    case 'step_4':
      return '#C6F6D5';
    case 'step_5':
      return '#FEB2B2';
    case 'step_6':
      return '#FBD38D';
    case 'step_7':
      return '#FEB2B2';
    case 'step_tw':
      return '#C6F6D5';
    case 'pending':
      return '#FAF089';
    case 'accepted':
      return '#C6F6D5';
    case 'rejected':
      return '#FEB2B2';
    default:
      return '#E2E8F0';
  }
};

export const getFontColor = (status: string): string => {
  switch (status) {
    case 'step_1':
      return '#322659';
    case 'step_2':
      return '#744210';
    case 'step_3':
      return '#744210';
    case 'step_4':
      return '#1C4532';
    case 'step_5':
      return '#63171B';
    case 'step_6':
      return '#652B19';
    case 'step_7':
      return '#63171B';
    case 'step_tw':
      return '#1C4532';
    case 'pending':
      return '#744210';
    case 'accepted':
      return '#1C4532';
    case 'rejected':
      return '#63171B';
    default:
      return 'black';
  }
};
